import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../_models/file-info-display-result-dto';
import { Utils } from 'cc-common';

export class VendorContractResultDto {
    vendorContractId: number;
    contractType: string;
    contractTerm: string;
    autoRenew: string;
    serviceFrequency: string;
    status: string;
    description: string;
    serviceCategory: string;

    @Type(() => Date)
    effectiveDate: Date;

    @Type(() => Date)
    endDate: Date;

    documentIds: number[];

    @Type(() => FileInfoDisplayResultDto)
    documents: FileInfoDisplayResultDto;

    wfVendorContractXrefId: number;

    get autoRenewDisplayText(): string {
        return Utils.notNullOrEmpty(this.autoRenew) ? this.autoRenew : null;
    }
}
